import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import InputLabel from '@material-ui/core/InputLabel'
import FormHelperText from '@material-ui/core/FormHelperText'

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 15
  },
  cssLabel: {
    '&$cssFocused': {
      color: 'rgba(0, 0, 0, 0.54)'
    }
  },
  cssFocused: {}
})

function TimePicker(props) {
  const { classes, placeholder, value, onChange, disabled, error = '' } = props

  return (
    <form className={classes.container} noValidate>
      <InputLabel
        shrink
        FormLabelClasses={{
          root: classes.cssLabel,
          focused: classes.cssFocused
        }}
      >
        {placeholder}
      </InputLabel>
      <TextField
        id={'time'}
        type={'time'}
        value={value}
        onChange={event => onChange(event.target.value)}
        disabled={disabled}
        error={error !== ''}
        inputProps={{
          step: 300
        }}
        fullWidth
      />
      <FormHelperText id={'name-error-text'}>{error}</FormHelperText>
    </form>
  )
}

TimePicker.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(TimePicker)



// WEBPACK FOOTER //
// ./src/components/common/TimePicker.js